import { render, staticRenderFns } from "./PpsList.vue?vue&type=template&id=bbfcdb76&"
import script from "./PpsList.vue?vue&type=script&lang=js&"
export * from "./PpsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports